export default __webpack_public_path__ + "static/media/applications-image-31.cb848a0c.jpg";